var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81218 5.81282C6.10508 5.51992 6.57995 5.51992 6.87284 5.81282L11.9994 10.9393L17.1259 5.81282C17.4188 5.51992 17.8937 5.51992 18.1866 5.81282C18.4794 6.10571 18.4794 6.58058 18.1866 6.87348L13.06 12L18.1866 17.1265C18.4794 17.4194 18.4794 17.8943 18.1866 18.1872C17.8937 18.4801 17.4188 18.4801 17.1259 18.1872L11.9994 13.0607L6.87284 18.1872C6.57995 18.4801 6.10508 18.4801 5.81218 18.1872C5.51929 17.8943 5.51929 17.4194 5.81218 17.1265L10.9387 12L5.81218 6.87348C5.51929 6.58058 5.51929 6.10571 5.81218 5.81282Z",
    fill: "#3F4F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItem);
export default __webpack_public_path__ + "static/media/delete-item.a96297fff7c13e0dad0d372c7feff4da.svg";
export { ForwardRef as ReactComponent };